import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { isUserModerator, createDisplayName } from '../misc/auth-utils'
import siemens_logo from '../static/graphics/logos/siemens_logo.svg'
import { signOut } from '../store/actions/auth'
import { unselectIdea } from '../store/actions/ideas'

export class Header extends Component {
    onLogout = () => {
        this.props.signOut()
    }

    render() {
        const authorizedNavigation = () => (
            <>
                <button
                    className="navbar-toggler"
                    data-toggle="collapse"
                    data-target="#navbar-items">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbar-items">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item">
                            <Link to="/" className="nav-link" href="#">
                                Home
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link to="/explore" className="nav-link">
                                Explore Ideas
                            </Link>
                        </li>

                        <li className="nav-item" onClick={() => this.props.unselectIdea()}>
                            <Link to="/submit" className="nav-link">
                                Submit an Idea!
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link
                                to="/leaderboards"
                                className="nav-link"
                                href="#">
                                Leaderboards
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link to="/faqs" className="nav-link" href="#">
                                FAQs
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link to="/about" className="nav-link" href="#">
                                About
                            </Link>
                        </li>

                        {isUserModerator(this.props.auth.user) && (
                            <li className="nav-item">
                                <Link
                                    to="/moderator"
                                    className="nav-link"
                                    href="#">
                                    Administration
                                </Link>
                            </li>
                        )}
                    </ul>

                    <ul className="navbar-nav navbar-right">
                        {this.props.auth.user && (
                            <li className="nav-item mr-3">
                                <span className=" text-secondary">
                                    {createDisplayName(this.props.auth.user)}
                                </span>
                            </li>
                        )}

                        <li className="nav-item">
                            <button
                                className="icon-btn"
                                onClick={this.onLogout}>
                                Logout
                            </button>
                        </li>
                    </ul>
                </div>
            </>
        )

        const navbarBase = (
            <header>
                <nav
                    id="header"
                    className="navbar navbar-expand-lg navbar-light">
                    <Link to="/" className="navbar-brand" href="#">
                        <img src={siemens_logo} alt="siemens logo" />
                    </Link>

                    {this.props.auth.isAuthenticated && authorizedNavigation()}
                </nav>
            </header>
        )
        
        return navbarBase
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
})

export default withRouter(connect(mapStateToProps, { signOut, unselectIdea })(Header))
